import {
  CLEAR_SELECTED_TAB,
  GET_SELECTED_TAB,
  SET_SELECTED_TAB,
} from "./SelectedTabTypes";

const initialState = {
  selectedTab: "",
};

const SelectedTabReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SELECTED_TAB:
      return {
        ...state,
      };
    case SET_SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      };

    case CLEAR_SELECTED_TAB:
      return {
        ...state,
        selectedTab: null,
      };
    default:
      return state;
  }
};

export default SelectedTabReducer;
